import { TutorialStep } from '@core/models';

const STEP_NUMBER = /^\d+\.\s*/;

export function resolveTutorialSteps(
  steps: TutorialStep[],
  hasTarget: (selector: string) => boolean
): TutorialStep[] {
  const kept = steps.filter(
    step =>
      !step.optional ||
      typeof step.element !== 'string' ||
      hasTarget(step.element)
  );

  if (kept.length === steps.length) {
    return steps;
  }

  return kept.map((step, index) => ({
    ...step,
    popover: {
      ...step.popover,
      description: step.popover.description?.replace(
        STEP_NUMBER,
        `${index + 1}. `
      ),
    },
  }));
}
